import { tableToExcel } from './excelExport';

export default {

    sanitizeVoidTags(html) {
        if (!html) return "";

        // Remove all closing tags for void elements
        html = html.replace(/<\/(input|img|br|hr|meta|link|area|base|col|command|embed|keygen|param|source|track|wbr)>/gi, '');

        // Ensure all void elements are self-closing
        html = html.replace(/<(input|img|br|hr|meta|link|area|base|col|command|embed|keygen|param|source|track|wbr)([^>]*?)(?<!\/)>/gi, '<$1$2 />');

        return html;
    },

    mapTo(array, key) {
        let value;
        for (let i = 0; i < array.length; i++) {
            if (Number(array[i].id) == Number(key)) {
                value = array[i].description;
            }
            if (i == array.length - 1)
                return value;
        }
    },

    tableToExcel,

}
